<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <div class="flex mt-2 md:mt-0">
        <router-link
          v-if="userCan('create.bank-transaction')"
          :to="{
            name: 'BankTransactionCreate',
            query: {
              is_transfer: 1,
            },
          }"
          class="
            button
            bg-yellow-400
            hover:bg-yellow-600
            hover:text-white
            poppins
            mr-2
          "
        >
          <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
          Transfer
        </router-link>
        <router-link
          v-if="userCan('create.bank-transaction')"
          :to="{ name: 'BankTransactionCreate' }"
          class="button button--primary poppins"
        >
          <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
          Transaction
        </router-link>
      </div>
    </template>
    <template #content>
      <div
        class="fixed top-0 left-0 z-50 bg-black bg-opacity-75 min-w-full min-h-full"
        v-show="summaryPopup"
      >
        <div class="p-10">
          <div class="flex justify-end">
            <BaseButton
              type="button"
              buttonClass="danger"
              @click="summaryPopup = false"
              >Close</BaseButton
            >
          </div>
          <h3 class="font-semibold mb-2 text-white">
            Transaction Summary:
            {{ dateFormat(formData.start_date, "DD MMM YYYY") }} -
            {{ dateFormat(formData.end_date, "DD MMM YYYY") }}
          </h3>
          <vue-good-table
            :key="tableSummaryKey"
            mode="remote"
            theme="polar-bear"
            :rows="tableDataSummary.rows"
            :columns="tableDataSummary.columns"
            :total-rows="tableDataSummary.totalRows"
            :isLoading="tableDataSummary.isLoading"
            :sort-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: false,
              perPageDropdown: [10, 15, 20, 25, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: tableDataSummary.currentPage,
              infoFn: tablePageInfo,
            }"
            styleClass="vgt-table striped bordered"
          >
          </vue-good-table>
        </div>
      </div>

      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Search</label>
            <input
              ref="search"
              type="text"
              class="form__input"
              placeholder="Name / Panel ID / Username / Ticket Number / Amount"
              v-model="formData.search"
            />
          </div>
          <div class="form-search__double" v-show="archivedNote">
            <label class="form__label">Archived {{ archivedNote }}</label>
            <select class="form__input" v-model="formData.archived">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Start Date</label>
            <date-picker
              v-model="formData.start_date"
              type="date"
              :editable="false"
              :clearable="false"
              input-class="form__input"
              value-type="YYYY-MM-DD"
              format="DD MMMM YYYY"
              placeholder="Start Date"
              @close="checkEndDate"
              :disabled-date="notAfterToday"
            ></date-picker>
          </div>
          <div class="form-search__double">
            <label class="form__label">End Date</label>
            <date-picker
              v-model="formData.end_date"
              type="date"
              :editable="false"
              :clearable="false"
              input-class="form__input"
              value-type="YYYY-MM-DD"
              format="DD MMMM YYYY"
              placeholder="End Date"
              :disabled-date="notBeforeStart"
            ></date-picker>
          </div>
        </div>
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Category</label>
            <select class="form__input" v-model="formData.category_id">
              <option value="">Show All</option>
              <option
                v-for="row in listBankTransactionCategory"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
          <div class="form-search__double">
            <label class="form__label">Date Order</label>
            <select class="form__input" v-model="tableData.sort_dir">
              <option value="asc">Oldest First</option>
              <option value="desc">Newest First</option>
            </select>
          </div>
        </div>

        <div class="form-search__action">
          <!-- <div class="w-3/12 flex"> -->
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >

            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="danger"
              @click="summaryPopup = true"
              >Show Summary</BaseButton
            >
          </div>
        </div>
      </form>

      <div class="form-search__single" v-if="userCan('export.transaction')">
        <FormNote class="mb-6"
          >Note: Export data dilakukan dari menu Export > Bank
          Transaction.</FormNote
        >
      </div>

      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :isLoading="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: [10, 15, 20, 25, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'date'">
            {{ dateFormat(props.row.date) }}
          </span>
          <span
            class="text-right block"
            v-else-if="props.column.field == 'amount'"
          >
            {{ props.row.amount }}
          </span>
          <span
            class="text-right block"
            v-else-if="props.column.field == 'balance'"
          >
            {{ props.row.balance }}
          </span>
          <span
            v-else-if="props.column.field == 'system_note'"
            class="font-semibold block text-pink-700"
          >
            {{ props.row.system_note }}
          </span>
          <span v-else-if="props.column.field == 'uuid'">
            <div v-if="props.row.member_transaction">
              <template
                v-if="
                  !props.row.member_transaction_account_member ||
                    !props.row.member_transaction_bank_account_member
                "
              >
                <span class="flex text-left items-center text-red-500">
                  <font-awesome-icon
                    :icon="['fas', 'exclamation-triangle']"
                    class="mr-2"
                    size="lg"
                  />Missing Data
                </span>
              </template>
              <template v-else>
                <router-link
                  v-if="props.row.category_id == 2"
                  :to="{
                    name: 'WithdrawEdit',
                    params: { id: props.row.member_transaction },
                  }"
                  class="
                    w-full
                    button
                    border-gray-600
                    button
                    border border-solid
                    hover:bg-gray-600
                    hover:text-white
                    transition-all
                    duration-200
                    text-center text-gray-600
                  "
                  ><font-awesome-icon
                    class="mr-1"
                    :icon="
                      props.row.status != 2 ? ['fas', 'edit'] : ['far', 'eye']
                    "
                  />
                  Edit</router-link
                >

                <router-link
                  v-else-if="props.row.category_id == 1"
                  :to="{
                    name: 'DepositEdit',
                    params: { id: props.row.member_transaction },
                  }"
                  class="
                    w-full
                    button
                    border-gray-600
                    button
                    border border-solid
                    hover:bg-gray-600
                    hover:text-white
                    transition-all
                    duration-200
                    text-center text-gray-600
                  "
                  ><font-awesome-icon
                    class="mr-1"
                    :icon="
                      props.row.status != 2 ? ['fas', 'edit'] : ['far', 'eye']
                    "
                  />
                  Edit</router-link
                >
              </template>
            </div>
            <div v-else>
              <span v-if="userCan('update.bank-transaction')">
                <router-link
                  :to="{
                    name: 'BankTransactionEdit',
                    params: { id: props.row.id },
                  }"
                  v-tooltip="
                    `Edit ${props.row.category_name} (${props.row.amount})`
                  "
                  class="table-action__link mx-2"
                >
                  <font-awesome-icon :icon="['fas', 'edit']" />
                </router-link>
              </span>

              <span v-if="userCan('delete.bank-transaction')">
                <button
                  class="table-action__link"
                  v-tooltip="
                    `Delete  ${props.row.category_name} (${props.row.amount})`
                  "
                  @click="deleteItem(props.row.id, props.row.category_name)"
                >
                  <font-awesome-icon :icon="['far', 'trash-alt']" />
                </button>
              </span>
            </div>
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";
import { datePickerMixin } from "@/mixins/datePickerMixin";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    DatePicker,
  },
  mixins: [showListMixin, datePickerMixin],
  data: () => {
    return {
      summaryPopup: false,
      tableSummaryKey: 0,
      archivedNote: "",
      exportToken: null,
      tableDataSummary: {
        isLoading: true,
        rows: [],
        totalRows: 0,
        limit: 50,
        currentPage: 1,
        search: "",
        filterParams: "",
        columns: [
          {
            label: "Category",
            field: "category",
          },
          {
            label: "Count",
            field: "count",
          },
          {
            label: "Amount",
            field: "amount",
          },
        ],
      },
      tableData: {
        columns: [
          {
            label: "Date",
            field: "date",
          },
          {
            label: "Category",
            field: "category_name",
          },
          {
            label: "System Note",
            field: "system_note",
          },
          {
            label: "Note",
            field: "note",
          },
          {
            label: "Amount",
            field: "amount",
          },
          {
            label: "Balance",
            field: "balance",
          },
          {
            label: "Created",
            field: "created",
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
        sort_by: "date",
        sort_dir: "desc",
      },
      listBankTransactionCategory: [],
      formData: {
        search: "",
        start_date: null,
        end_date: null,
        category_id: "",
        archived: 0,
      },
    };
  },
  created() {
    this.getBankTransactionCategory();
  },
  methods: {
    // checkSearch() {
    //   const searchParam = this.formData.search;
    //   const lastThree = searchParam.slice(searchParam.length - 3);
    //   const decimalSeparator = lastThree.charAt(0);

    //   if (decimalSeparator == ",")
    //   {
    //     let tempValue = searchParam.replace(",", '#');
    //     let newValue = (tempValue.replace(".", ",")).replace("#", ".");
    //     this.formData.search = newValue;
    //   }
    // },
    getBankTransactionSummary() {
      this.$http.get(
        process.env.VUE_APP_API_URL +
          "/bank-account/" +
          this.$route.params.bankId +
          "/summary"
      );
    },
    getBankTransactionCategory() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-transaction-category")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankTransactionCategory = response.data;
            }
          }
        });
    },
    exportResults() {
      window.open(
        process.env.VUE_APP_API_URL +
          `/export/${this.$store.getters.getToken}/${this.exportToken}`
      );
    },
    reset() {
      this.formData.search = "";
      this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD");
      this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD");
      this.tableData.sort_dir = "desc";
      this.tableData.limit = 10;
      this.tableData.archived = 0;

      if (this.$route.query.search == undefined) {
        this.tableKey++;
        this.tableSummaryKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "BankTransactionList" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.tableData.currentPage = 1;
        this.$router
          .replace({
            query: {
              archived: this.formData.archived,
              search: this.formData.search,
              start_date: this.formData.start_date,
              end_date: this.formData.end_date,
              category_id: this.formData.category_id,
              sort_dir: this.tableData.sort_dir,
              tz: new Date().getTime(),
            },
          })
          .catch(() => {});
      }
    },
    loadTableData() {
      this.tableData.isLoading = true;
      this.tableDataSummary.isLoading = true;

      const queryParams = this.$route.query;
      let searchParam = "";
      if (queryParams.search != undefined) {
        this.formData = { ...this.formData, ...this.$route.query };
        this.tableData.sort_dir = this.$route.query.sort_dir;

        for (const key in queryParams) {
          if (key != "sort_dir") {
            searchParam += `&${key}=${queryParams[key]}`;
          }
        }
      } else {
        searchParam += `&start_date=${this.formData.start_date}&end_date=${this.formData.end_date}&archived=${this.formData.archived}`;
      }

      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `${this.$route.path}?page=${this.tableData.currentPage}&limit=${this.tableData.limit}&sort_by=${this.tableData.sort_by}&sort_dir=${this.tableData.sort_dir}${searchParam}`
        )
        .then((res) => {
          this.tableData.rows = res.data.data;
          this.tableData.totalRows = res.data.total;
          this.archivedNote = res.data.archived;
          // this.exportToken = res.data.export_token;
          this.$emit("getBankData");
        })
        .finally(() => {
          this.tableData.isLoading = false;
        });

      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `/bank-account/${this.$route.params.bankId}/summary?page=1${searchParam}`
        )
        .then((res) => {
          this.tableDataSummary.rows = res.data.data;
          this.tableDataSummary.totalRows = res.data.total;
        })
        .finally(() => {
          this.tableDataSummary.isLoading = false;
        });
    },
    dateFormat(date, format = "DD MMM YYYY - HH:mm:ss") {
      return this.moment(date).format(format);
    },
    notBeforeStart(date) {
      // End date must be < start and <= today
      const maxDays = 40;
      let maxDate = new Date(this.formData.start_date);
      maxDate.setDate(maxDate.getDate() + maxDays);

      return (
        date <
          new Date(new Date(this.formData.start_date).setHours(0, 0, 0, 0)) ||
        date > maxDate ||
        date > new Date()
      );
    },
    checkEndDate() {
      const maxDays = 40;

      const startDate = new Date(this.formData.start_date);
      const endDate = new Date(this.formData.end_date);

      let maxDate = startDate;
      maxDate.setDate(maxDate.getDate() + maxDays);

      if (
        new Date(this.formData.start_date) >=
        new Date(new Date(this.formData.end_date).setHours(0, 0, 0, 0))
      ) {
        // If start > end, set end = start
        this.formData.end_date = this.formData.start_date;
      } else if (endDate > maxDate) {
        // If end > maxDays, set end = maxDate
        this.formData.end_date = this.moment(maxDate).format("YYYY-MM-DD");
      }
    },
    deleteItem(id, name) {
      this.$swal({
        title: "Delete " + name,
        text: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
      }).then((res) => {
        if (res.value) {
          this.$store.commit("toggleLoading");
          this.$http
            .delete(process.env.VUE_APP_API_URL + this.$route.path + "/" + id)
            .then((res) => {
              this.$store.commit("toggleLoading");
              if (res.status == 200) {
                this.$swal({
                  title: "All done!",
                  text: res.data.message,
                  icon: "success",
                }).then(() => {
                  this.loadTableData();
                });
              }
            })
            .finally(() => {});
        }
      });
    },
  },
};
</script>
